export default 'mapsApp';
